import React from "react";
import { Table, Typography } from "antd";

const { Text, Title } = Typography;

const columns = [
  {
    title: "Memo ID",
    dataIndex: "memoId",
  },
  {
    title: "Created By",
    dataIndex: "createdBy",
  },
  {
    title: "Memo",
    dataIndex: "memo",
  },
  {
    title: "Created On",
    dataIndex: "createdOn",
  },
  {
    title: "Actions",
    render: () => {
      <Text>incentives</Text>;
    },
  },
];

const Memo = (props) => {
  const { interestRateChartList } = props;
  return <Table columns={columns} dataSource={interestRateChartList} />;
};

export default Memo;
